import { createAsyncThunk } from '@reduxjs/toolkit';
import { BuyerSelectionPaidBefore } from '../../../models/MarketplaceCommerce/BuyerSelectionPaidBefore';

// [#1309] The Buyers a selection step's fee was already paid for: the selection pop-ups price them at no charge.
export const GetBuyerSelectionPaidBefore = createAsyncThunk(
    'marketplace/pricing/getBuyerSelectionPaidBefore',
    async ({ engagementId, eventId }: { engagementId: number; eventId: string }, { getState }: any) => {
        const axios = getState().core.axios;
        const response = await axios.get(
            `/api/MarketplaceCommerce/BuyerSelectionPaidBefore/${engagementId}/${eventId}`
        );
        return response.data as BuyerSelectionPaidBefore;
    }
);
